import { render, staticRenderFns } from "./LightboxGallery.vue?vue&type=template&id=16a9ec1b&scoped=true"
import script from "./LightboxGallery.vue?vue&type=script&lang=js"
export * from "./LightboxGallery.vue?vue&type=script&lang=js"
import style0 from "./LightboxGallery.vue?vue&type=style&index=0&id=16a9ec1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9ec1b",
  null
  
)

export default component.exports